import { dramas } from "@/mocks/dramas";
import { newReleases } from "@/mocks/content";
import type { Drama } from "@/pages/home/types";

const dramaMap = new Map(dramas.map((d) => [d.id, d]));

export default function NewReleaseSection() {
  return (
    <section id="new" className="w-full bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div>
          <span className="font-label text-sm font-medium text-secondary-700">刚刚开播</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            新剧上线 · 最近值得看的新作
          </h2>
          <p className="mt-3 max-w-2xl font-body text-sm leading-relaxed text-foreground-600">
            新剧最容易踩雷，所以我们只挑讨论度和完成度都在线的作品。下面是近期开播或全集上线的剧集，附一句话看点。
          </p>
        </div>

        <ul className="mt-8 divide-y divide-background-200/70 overflow-hidden rounded-lg border border-background-200/70 bg-background-50">
          {newReleases.map((item) => {
            const drama = dramaMap.get(item.id) as Drama | undefined;
            if (!drama) return null;
            return (
              <li
                key={item.id}
                className="flex flex-col gap-3 p-4 transition-colors hover:bg-background-100/70 sm:flex-row sm:items-center md:gap-5 md:p-5"
              >
                <div className="h-20 w-14 shrink-0 overflow-hidden rounded-md bg-background-200">
                  <img
                    src={drama.poster}
                    alt={`${drama.title} 剧集海报`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <h3 className="font-heading text-base font-semibold text-foreground-950">
                      {drama.title}
                    </h3>
                    <span className="rounded-full bg-primary-100 px-2 py-0.5 font-label text-[11px] text-primary-700">
                      {item.badge}
                    </span>
                  </div>
                  <p className="mt-1 font-label text-xs text-foreground-500">
                    {item.date} 上线 · {drama.platform} · {drama.episodes}集
                  </p>
                  <p className="mt-1.5 font-body text-xs leading-relaxed text-foreground-700">
                    {item.note}
                  </p>
                </div>
                <div className="flex shrink-0 items-center gap-3 self-start sm:self-center">
                  <span className="font-heading text-lg font-bold text-accent-700">
                    {drama.rating.toFixed(1)}
                  </span>
                  <span className="font-label text-[11px] text-foreground-500">口碑分</span>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}